/**
 * Created by FangShenglong at 2018/12/07
 */
import cacheKeys from '@src/common/config/cacheKeys';
import fetch from '@src/common/lib/axios'

/**
 * 登录成功后缓存用户相关信息
 * @param commit
 * @param param
 * @constructor
 */
export const loginSuccess = ({ commit }, param) => {
  param = param || {};
  commit(cacheKeys.CACHE_USER_INFO, param);
};

/**
 * 清除用户相关的缓存信息
 * @param commit
 * @param param
 */
export const clearUserCache = ({ commit }) => {
  // 在清除缓存前，先清空用户信息，因为调用清除缓存操作为异步操作，未能及时清除用户信息，导致无法跳转至登录页面
  commit(cacheKeys.CACHE_USER_INFO, null);
  // 清空用户主菜单信息
  commit(cacheKeys.USER_AUTH_MENU, null);
  // 清空用户当前的中心信息
  commit(cacheKeys.CURRENT_CENTER_INFO, null);
  // 清空当前页面标题
  commit(cacheKeys.PAGE_TITLE, null);
  // 清空页面顶部打开的tab页签
  commit(cacheKeys.MENU_TABS_LIST, null);
};

/**
 * 清除用户信息，将用户信息置为空
 * @param commit
 * @param param
 */
export const clearUserInfo = ({ commit }) => {
  commit(cacheKeys.CACHE_USER_INFO, null);
};

/**
 * 缓存token
 * @param commit
 * @param param
 */
export const SetToken = ({ commit }, data) => {
  commit('SET_ACCESS_TOKEN', data.access_token)
};

/**
 * 清除用户信息，将用户信息置为空
 * @param commit
 * @param param
 */
export const clearToken = ({ commit }) => {
  commit('SET_USER_INFO', null)
  commit('SET_ACCESS_TOKEN', '')
};

/**
 * 缓存用户当前选择的中心区域
 * @param commit
 * @param param
 */
export const setControlInfo = ({ commit }, param) => {
  commit(cacheKeys.CURRENT_CENTER_INFO, param);
};

/**
 * 缓存当前页面标题
 * @param commit
 * @param param
 */
export const setPageTitle = ({ commit }, param) => {
  commit(cacheKeys.PAGE_TITLE, param);
};

/**
 * 缓存当前语种
 * @param commit
 * @param param
 */
export const setCurrentLanguage = ({ commit }, param) => {
  commit(cacheKeys.CURRENT_LANGUAGE, param);
};

/**
 * 缓存当前主题
 * @param commit
 * @param param
 */
export const setCurrentTheme = ({ commit }, param) => {
  commit(cacheKeys.CURRENT_THEME, param);
};

/**
 * 缓存当前表格条数
 * @param commit
 * @param param
 */
export const setCurrentPagesize = ({ commit }, param) => {
  commit(cacheKeys.CURRENT_PAGESIZE, param);
};